import React, { Component } from 'react';

/* tslint:disable:no-var-requires */
const styles = require('./styles.module.scss');

import { ConnectedBubblePicker, ConnectedSlider, ConnectedToggle, LEVER_TYPE } from '../../pages/modelLevers/panes/numberSelectors';

interface IProps {
  scenarioKey: string;
  // Levers
  publicTransitLever: number;
  nonMotorizedLever: number;
  sharedMobilityLever: number;
  // handle functions
  setScenarioNumber: (propName: string, value: number, scenarioKey: string) => void;
}

class ScenarioLevers extends Component<IProps, any> {

  constructor(props: IProps) {
    super(props);
  }

  public render() {
    const {scenarioKey} = this.props;

    return <div className={styles.leverPane}>
        {/* <p>Modal Split Intensities</p> */}
        <p className={styles.leverTitle}>Public Transit</p>
        <ConnectedBubblePicker start={0} end={4} leverName="publicTransit" scenarioKey={scenarioKey} />
        <p className={styles.leverTitle}>Non-motorized</p>
        <ConnectedBubblePicker start={0} end={4} leverName="nonMotorizedTransit" scenarioKey={scenarioKey} />
        <p className={styles.leverTitle}>Shared Mobility</p>
        <ConnectedBubblePicker start={0} end={4} leverName="sharedMobility" scenarioKey={scenarioKey} />

        <p className={styles.sliderSectionHeading}>
          Vehicle Electrification Goals (%)
        </p>

        <p className={styles.sliderTitle}>Private</p>
        <ConnectedSlider leverName={LEVER_TYPE.privateElectrificationVehicleGoal} scenarioKey={scenarioKey} hideLabels={true} />

        <p className={styles.sliderTitle}>Public / Commercial</p>
        <ConnectedSlider leverName={LEVER_TYPE.publicCommercialElectrificationVehicleGoal} scenarioKey={scenarioKey} hideLabels={true} />

        <p className={styles.sliderSectionHeading}>
          Has renewable energy target?
        </p>

        <ConnectedToggle scenarioKey={scenarioKey} leverName={"hasRenewableEnergyTarget"} />
      </div>;
  }
}


export default (ScenarioLevers);



// WEBPACK FOOTER //
// ./src/components/scenarioCard/levers.tsx